export const userFiltersConfig = [
  {
    name: 'profileFirstName',
    label: 'Имя',
    type: 'text' as const,
    placeholder: 'Все',
    apiKey: 'profile.firstName',
  },
  {
    name: 'profileLastName',
    label: 'Фамилия',
    type: 'text' as const,
    placeholder: 'Все',
    apiKey: 'profile.lastName',
  },
  {
    name: 'email',
    label: 'Email',
    type: 'text' as const,
    placeholder: 'Все',
  },
  {
    name: 'profilePhone',
    label: 'Номер телефона',
    type: 'phone' as const,
    placeholder: 'Все',
    apiKey: 'profile.phone',
  },
  {
    name: 'roleName',
    label: 'Группа',
    type: 'select' as const,
    options: [
      { value: 'recruiter', label: 'Рекрутер' },
      { value: 'manager', label: 'Менеджер' },
      { value: 'admin', label: 'Администратор' },
      { value: 'support', label: 'Служба поддержки' },
    ],
    clearable: true,
    placeholder: 'Все',
    apiKey: 'role.name',
  },
  {
    name: 'companyName',
    label: 'Компания',
    type: 'select-company' as const,
    placeholder: 'Все',
    apiKey: 'company.id',
  },
  {
    name: 'isActive',
    label: 'Статус',
    type: 'select' as const,
    options: [
      { value: 'true', label: 'Активен' },
      { value: 'false', label: 'Неактивен' },
    ],
    clearable: true,
    placeholder: 'Все',
  },
];

export const initialValues = {
  profileFirstName: '',
  profileLastName: '',
  email: '',
  profilePhone: '',
  roleName: null,
  companyName: null,
  isActive: null,
};
